import { forwardRef, useCallback, useLayoutEffect, useState } from "react";
import { useSelector, useStore } from "react-redux";
import classNames from "classnames";

import { assignForwardedRef } from "./assignForwardedRef";

const PushableContainer = ({ preventPush, ...props }, ref) => {
  const pushableContainersOffset = useSelector(
    ({ styling }) => styling.pushableContainersOffset
  );

  const [container, setContainer] = useState();

  const containerRef = useCallback(
    node => {
      assignForwardedRef(ref, node);

      setContainer(node);
    },
    [ref]
  );

  const className = classNames("pushable-container", props.className);

  // We use top padding and not margins to avoid margin overlapping between the container
  // and its child elements
  const paddingTop = preventPush ? 0 : pushableContainersOffset;

  useLayoutEffect(() => {
    if (!container) return;

    container.style.setProperty(
      "padding-top",
      `${paddingTop}px`,
      paddingTop ? "important" : null
    );
  }, [container, paddingTop]);

  return (
    <div {...props} className={className} ref={containerRef}>
      {props.children}
    </div>
  );
};

// This allows to get a function that returns the current `pushableContainersOffset` value
// from the redux store at a given point, without having to subscribe to its updates. This
// is useful for elements that need to calculate their height, without the padding of the
// pushable containers, and which actual useful height doesn't depend on the
// pushableContainersOffset, like the <StickyTitleBar/> component
//
export const useGetPushableContainersOffset = () => {
  const store = useStore();

  return useCallback(() => store.getState().styling?.pushableContainersOffset, [store]);
};

export default forwardRef(PushableContainer);
